import { render, staticRenderFns } from "./Standardnutra-ingredient.vue?vue&type=template&id=e53ef78e&scoped=true&"
import script from "./Standardnutra-ingredient.vue?vue&type=script&lang=js&"
export * from "./Standardnutra-ingredient.vue?vue&type=script&lang=js&"
import style0 from "./Standardnutra-ingredient.vue?vue&type=style&index=0&id=e53ef78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53ef78e",
  null
  
)

export default component.exports